export default {
    methods: {
        hasTransactionClickID(transaction) {
            if (! this.hasSessionMetaData(transaction)) {
                return false;
            }
            const transactionMetaData = this.getTransactionMetaData(transaction)
            if (!transactionMetaData.hasOwnProperty("ga")) {
                return false;
            }
            if (!transactionMetaData.ga.hasOwnProperty("click_id")) {
                return false;
            }
            return !!transactionMetaData.ga.click_id;
        },

        hasGAIntegration(transaction) {
            if (! this.hasSessionMetaData(transaction)) {
                return false;
            }
            const transactionMetaData = this.getTransactionMetaData(transaction)
            if (!transactionMetaData.hasOwnProperty("ga")) {
                return false;
            }
            return !!transactionMetaData.ga;
        },

        hasBAIntegration(transaction) {
            if (! this.hasSessionMetaData(transaction)) {
                return false;
            }
            const transactionMetaData = this.getTransactionMetaData(transaction)
            if (!transactionMetaData.hasOwnProperty("ba")) {
                return false;
            }
            return !!transactionMetaData.ba;
        },

        hasFBIntegration(transaction) {
            if (! this.hasSessionMetaData(transaction)) {
                return false;
            }
            const transactionMetaData = this.getTransactionMetaData(transaction)
            if (!transactionMetaData.hasOwnProperty("fb")) {
                return false;
            }
            return !!transactionMetaData.fb;
        },

        hasKickbiteIntegration(transaction) {
            if (! this.hasSessionMetaData(transaction)) {
                return false;
            }
            const transactionMetaData = this.getTransactionMetaData(transaction)
            if (!transactionMetaData.hasOwnProperty("kb")) {
                return false;
            }
            return !!transactionMetaData.kb;
        },

        hasSessionMetaData(transaction) {
            if (transaction.session_meta_data === null) {
                return false;
            }
            if (transaction.session_meta_data === 'null') {
                return false;
            }

            return true
        },

        getTransactionMetaData(transaction) {
            if (typeof (transaction.session_meta_data) === "object") {
                return transaction.session_meta_data;
            }
            if (Object.values(this.transaction.session_meta_data).length) {
                return JSON.parse(transaction.session_meta_data);
            }
            return null
        }


    }
};
